import { render, staticRenderFns } from "./PrescriptionItemCheckbox.vue?vue&type=template&id=5c39737a&scoped=true"
import script from "./PrescriptionItemCheckbox.vue?vue&type=script&lang=ts"
export * from "./PrescriptionItemCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./PrescriptionItemCheckbox.vue?vue&type=style&index=0&id=5c39737a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c39737a",
  null
  
)

export default component.exports